import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  TOKEN_PROGRAM_ID,
  getAssociatedTokenAddress,
  createAssociatedTokenAccountIdempotentInstruction,
} from '@solana/spl-token-0.4';
import { AccountInfo, Connection, PublicKey, TransactionInstruction } from '@solana/web3.js';

export const getATA = async (
  tokenMint: PublicKey,
  owner: PublicKey,
  connection: Connection,
): Promise<{ account: AccountInfo<Buffer> | null; toAccount: PublicKey }> => {
  let toAccount;
  try {
    toAccount = await getAssociatedTokenAddress(tokenMint, owner, true);
    const account = await connection.getAccountInfo(toAccount);

    return { account, toAccount };
  } catch (e) {
    /* handle error */
    console.error('Error::getATA', e);
    throw e;
  }
};

export const getOrCreateATAInstruction = async (
  tokenMint: PublicKey,
  owner: PublicKey,
  connection: Connection,
  payer: PublicKey = owner,
): Promise<[PublicKey, TransactionInstruction?]> => {
  try {
    const { account, toAccount } = await getATA(tokenMint, owner, connection);
    if (!account) {
      const ix = createAssociatedTokenAccountIdempotentInstruction(payer, toAccount, owner, tokenMint);
      return [toAccount, ix];
    }
    return [toAccount, undefined];
  } catch (e) {
    /* handle error */
    console.error('Error::getOrCreateATAInstruction', e);
    throw e;
  }
};
